"use strict";
/*
 * HSTreeView
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSTreeView = /** @class */ (function (_super) {
    __extends(HSTreeView, _super);
    function HSTreeView(el, options, events) {
        var _this = _super.call(this, el, options, events) || this;
        _this.items = [];
        var data = el.getAttribute('data-hs-tree-view');
        var dataOptions = data ? JSON.parse(data) : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.controlBy = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.controlBy) || 'button';
        _this.autoSelectChildren = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.autoSelectChildren) || false;
        _this.isIndeterminate = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.isIndeterminate) || true;
        _this.init();
        return _this;
    }
    HSTreeView.prototype.init = function () {
        this.createCollection(window.$hsTreeViewCollection, this);
        HSTreeView.group += 1;
        this.initItems();
    };
    HSTreeView.prototype.initItems = function () {
        var _this = this;
        this.el.querySelectorAll('[data-hs-tree-view-item]').forEach(function (el, ind) {
            var _a, _b;
            var data = JSON.parse(el.getAttribute('data-hs-tree-view-item'));
            if (!el.id)
                el.id = "tree-view-item-".concat(HSTreeView.group, "-").concat(ind);
            var concatData = __assign(__assign({}, data), { id: (_a = data.id) !== null && _a !== void 0 ? _a : el.id, path: _this.getPath(el), isSelected: (_b = data.isSelected) !== null && _b !== void 0 ? _b : false });
            _this.items.push(concatData);
            if (_this.controlBy === 'checkbox')
                _this.controlByCheckbox(el, concatData);
            else
                _this.controlByButton(el, concatData);
        });
    };
    HSTreeView.prototype.controlByButton = function (el, data) {
        var _this = this;
        el.addEventListener('click', function (evt) {
            evt.stopPropagation();
            if (el.classList.contains('disabled'))
                return false;
            if (!evt.metaKey && !evt.shiftKey)
                _this.unselectItem(data);
            _this.selectItem(el, data);
            _this.fireEvent('click', {
                el: el,
                data: data,
            });
            (0, utils_1.dispatch)('click.hs.treeView', _this.el, {
                el: el,
                data: data,
            });
        });
    };
    HSTreeView.prototype.controlByCheckbox = function (el, data) {
        var _this = this;
        var control = el.querySelector("input[value=\"".concat(data.value, "\"]"));
        if (!!control)
            control.addEventListener('change', function () {
                if (_this.autoSelectChildren) {
                    _this.selectItem(el, data);
                    if (data.isDir)
                        _this.selectChildren(el, data);
                    _this.toggleParent(el);
                }
                else
                    _this.selectItem(el, data);
            });
    };
    HSTreeView.prototype.getItem = function (id) {
        return this.items.find(function (el) { return el.id === id; });
    };
    HSTreeView.prototype.getPath = function (el) {
        var _a;
        var path = [];
        var parent = el.closest('[data-hs-tree-view-item]');
        while (!!parent) {
            var data = JSON.parse(parent.getAttribute('data-hs-tree-view-item'));
            path.push(data.value);
            parent = (_a = parent.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-hs-tree-view-item]');
        }
        return path.reverse().join('/');
    };
    HSTreeView.prototype.unselectItem = function (exception) {
        var _this = this;
        if (exception === void 0) { exception = null; }
        var selectedItems = this.getSelectedItems();
        if (exception)
            selectedItems = selectedItems.filter(function (el) { return el.id !== exception.id; });
        if (selectedItems.length) {
            selectedItems.forEach(function (el) {
                var selectedElement = document.querySelector("#".concat(el.id));
                selectedElement.classList.remove('selected');
                _this.changeItemProp(el.id, 'isSelected', false);
            });
        }
    };
    HSTreeView.prototype.selectItem = function (el, data) {
        if (data.isSelected) {
            el.classList.remove('selected');
            this.changeItemProp(data.id, 'isSelected', false);
        }
        else {
            el.classList.add('selected');
            this.changeItemProp(data.id, 'isSelected', true);
        }
    };
    HSTreeView.prototype.selectChildren = function (el, data) {
        var _this = this;
        var items = el.querySelectorAll('[data-hs-tree-view-item]');
        Array.from(items)
            .filter(function (elI) { return !elI.classList.contains('disabled'); })
            .forEach(function (elI) {
            var initialItemData = elI.id ? _this.getItem(elI.id) : null;
            if (!initialItemData)
                return false;
            if (data.isSelected) {
                elI.classList.add('selected');
                _this.changeItemProp(initialItemData.id, 'isSelected', true);
            }
            else {
                elI.classList.remove('selected');
                _this.changeItemProp(initialItemData.id, 'isSelected', false);
            }
            var currentItemData = _this.getItem(elI.id);
            var control = elI.querySelector("input[value=\"".concat(currentItemData.value, "\"]"));
            if (_this.isIndeterminate)
                control.indeterminate = false;
            if (currentItemData.isSelected)
                control.checked = true;
            else
                control.checked = false;
        });
    };
    HSTreeView.prototype.toggleParent = function (el) {
        var _this = this;
        var _a, _b;
        var parent = (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-hs-tree-view-item]');
        var _loop_1 = function () {
            var items = parent.querySelectorAll('[data-hs-tree-view-item]:not(.disabled)');
            var data = JSON.parse(parent.getAttribute('data-hs-tree-view-item'));
            var control = parent.querySelector("input[value=\"".concat(data.value, "\"]"));
            var hasUnchecked = false;
            var checkedItems = 0;
            items.forEach(function (elI) {
                var dataI = _this.getItem(elI.id);
                if (dataI.isSelected)
                    checkedItems += 1;
                if (!dataI.isSelected)
                    hasUnchecked = true;
            });
            if (hasUnchecked) {
                parent.classList.remove('selected');
                this_1.changeItemProp(parent.id, 'isSelected', false);
                control.checked = false;
            }
            else {
                parent.classList.add('selected');
                this_1.changeItemProp(parent.id, 'isSelected', true);
                control.checked = true;
            }
            if (this_1.isIndeterminate) {
                if (checkedItems > 0 && checkedItems < items.length)
                    control.indeterminate = true;
                else
                    control.indeterminate = false;
            }
            parent = (_b = parent.parentElement) === null || _b === void 0 ? void 0 : _b.closest('[data-hs-tree-view-item]');
        };
        var this_1 = this;
        while (!!parent) {
            _loop_1();
        }
    };
    // Public methods
    HSTreeView.prototype.update = function () {
        var _this = this;
        this.items.map(function (el) {
            var selector = document.querySelector("#".concat(el.id));
            if (el.path !== _this.getPath(selector))
                el.path = _this.getPath(selector);
            return el;
        });
    };
    HSTreeView.prototype.getSelectedItems = function () {
        return this.items.filter(function (el) { return el.isSelected; });
    };
    HSTreeView.prototype.changeItemProp = function (id, prop, val) {
        this.items.map(function (el) {
            // @ts-ignore
            if (el.id === id)
                el[prop] = val;
            return el;
        });
    };
    // Static methods
    HSTreeView.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsTreeViewCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element.el
            : null;
    };
    HSTreeView.autoInit = function () {
        if (!window.$hsTreeViewCollection)
            window.$hsTreeViewCollection = [];
        document
            .querySelectorAll('[data-hs-tree-view]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsTreeViewCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSTreeView(el);
        });
    };
    // Backward compatibility
    HSTreeView.on = function (evt, target, cb) {
        var elInCollection = window.$hsTreeViewCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection)
            elInCollection.element.events[evt] = cb;
    };
    HSTreeView.group = 0;
    return HSTreeView;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSTreeView.autoInit();
    // Uncomment for debug
    // console.log('Tree view collection:', window.$hsTreeViewCollection);
});
if (typeof window !== 'undefined') {
    window.HSTreeView = HSTreeView;
}
exports.default = HSTreeView;
